export default __webpack_public_path__ + "static/media/trash.c498bf75.svg";